import React from 'react'
import { makeStyles } from '@mui/styles'
import { FONT_SIZES } from '@/theme'
import clsx from 'clsx'

const DividerWithText = ({ text, solid, className }) => {
  const classes = useStyles()
  return (
    <div className={clsx(classes.root, className, { solid })}>
      {text}
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    fontSize: FONT_SIZES.tiny,
    color: theme.darkGrey,
    '&:before, &:after': {
      content: '""',
      flex: '1 1',
      borderBottom: `1px dotted ${theme.borderColor}`,
      margin: 'auto',
    },
    '&.solid': {
      '&:before, &:after': {
        borderBottom: `1px solid ${theme.borderColor}`,
      },
    },
    '&:before': {
      marginRight: '1em',
    },
    '&:after': {
      marginLeft: '1em',
    },
  },
}))

export default DividerWithText
